export default __webpack_public_path__ + "c334108e579d71bec336f0a73f63f5fb.png";